import React, { useEffect, useState } from 'react';
import {
  College,
  Cmty,
  Hero,
  Layout, 
  Pricing,
  Process,
} from './section';

const Landing = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
      };

      handleResize(); // Run on mount
      window.addEventListener('resize', handleResize);

      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  return (
    <div key={isMobile} className="flex flex-col mt-[100px]">
      <Hero />

      {/* Properly align Pricing only on mobile */}
      <div className={isMobile ? "flex flex-col items-center w-full px-4 max-w-md mx-auto" : ""}>
        <Pricing />
      </div>

      <Process />
      <Layout />
      <Cmty />
      <College />
    </div>
  );
};

export default Landing;
